<template>
    <main class="layout__main layout__main--no-top-padding">
        <BaseHeader
            v-if="pending || headerImage"
            :placeholder="pending"
            :image="headerImage"
        />

        <article class="bleed">
            <BaseSection class="section--wide">
                <template #title>
                    <h1>
                        <template v-if="topic">{{ topic.title }}</template>
                        <template v-else>
                            <ContentPlaceholdersText :lines="1" />
                        </template>
                    </h1>
                </template>
            </BaseSection>

            <FlexibleSections
                :sections="topic?.sections && Array.isArray(topic?.sections) ? topic.sections : []"
                :placeholder="pending ? 'overview' : undefined"
                data-wide
            />
        </article>
    </main>
</template>

<script setup>
import {startOfDay} from 'date-fns';
import TopicQuery from '~/graphql/queries/Topic.graphql';

const { activeSite } = useMultisite();
const { variables } = useCraftVariables();
const slug = useRoute().params.slug;
const response = await useLazyAsyncQuery({
    query: TopicQuery,
    variables: {
        ...variables,
        slug,
        minDate: ['>=' + startOfDay(new Date()).toISOString()],
    },
});

const {
    craftEntry: topic,
    headerImage,
    pending,
} = usePageQuery(
    response,
    { entryKey: 'topic', activeSite }
);

// todo
// if (!topic || !topic.value) {
//     notFound = true;
// }
</script>
